import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const scoreSuggestionSchema = z.object({
  id: z.string(),
  resumeId: z.string(),
  jobDescriptionHash: z.string(),
  jobDescription: z.string(),
  resumeSnapshot: z.any(),
  atsScore: z.number(),
  skillsMatchPercentage: z.number().nullable().optional(),
  experienceRelevance: z.number().nullable().optional(),
  requirementsAnalysis: z.any(),
  scoreAdjustments: z.any(),
  matchingKeywords: z.any(),
  missingKeywords: z.any(),
  improvementSuggestions: z.any(),
  summary: z.string(),
  previousSuggestionId: z.string().nullable().optional(),
  wasRetried: z.boolean(),
  createdAt: z.coerce.date(),
});

// const createScoreSuggestionSchema = scoreSuggestionSchema.omit({
//   id:true, createdAt:true
// })

export class ScoreSuggestionDto extends createZodDto(scoreSuggestionSchema) {}
